export default __webpack_public_path__ + "static/media/end-flow.c0e6d920.svg";